import { useQuery } from '@tanstack/react-query';
import { api } from '@/api/client';
import type {
  ConsumptionDeviationResponse,
  DepartmentsResponse,
} from '@/types/departments';

export function useDepartmentsSummary() {
  return useQuery<DepartmentsResponse>({
    queryKey: ['departments', 'summary'],
    queryFn: async () => {
      const { data } = await api.get<DepartmentsResponse>('/departments/summary');
      return data;
    },
    staleTime: 60_000,
  });
}

/**
 * Per-vehicle consumption vs the fleet standard.
 *
 * Separate query from the summary on purpose: the summary answers "who spends
 * most" (size-dominated) and this answers "who is abnormal for their size".
 * They are different questions and the SPA renders them as different sections.
 */
export function useConsumptionDeviation() {
  return useQuery<ConsumptionDeviationResponse>({
    queryKey: ['departments', 'consumption-deviation'],
    queryFn: async () => {
      const { data } = await api.get<ConsumptionDeviationResponse>(
        '/departments/consumption-deviation',
      );
      return data;
    },
    staleTime: 60_000,
  });
}
